const POLL_MS = 100;
export const FIREBASE_REMOTE_CONFIG_WAIT_MS = 10000;

function isFirebaseRemoteConfigReady () {
  return typeof window !== 'undefined'
    && !!window.firebase
    && typeof window.firebase.remoteConfig === 'function';
}

/**
 * Waits until deferred Firebase Remote Config SDK is available.
 * Uses wall-clock timeout so background timer throttling cannot stall fallback forever.
 * @param {number} [timeoutMs]
 * @returns {Promise<void>}
 */
export default function waitForFirebaseRemoteConfig (
  timeoutMs = FIREBASE_REMOTE_CONFIG_WAIT_MS
) {
  return new Promise((resolve, reject) => {
    if (isFirebaseRemoteConfigReady()) {
      resolve();
      return;
    }

    const startedAt = Date.now();
    const intervalId = setInterval(() => {
      if (isFirebaseRemoteConfigReady()) {
        clearInterval(intervalId);
        resolve();
        return;
      }

      if (Date.now() - startedAt >= timeoutMs) {
        clearInterval(intervalId);
        reject(new Error('Firebase remoteConfig unavailable'));
      }
    }, POLL_MS);
  });
}
